import { Component } from '@angular/core';

@Component({
    templateUrl: './calendar-help.component.html',
    standalone: false
})
export class CalendarHelpComponent{}

